const validate = (values) => {
    let errors = {};
    
  if (!values.oldPassword?.trim()) {
    errors.oldPassword = 'Old password is required';
  } else if (values.oldPassword.length < 6) {
    errors.oldPassword = 'Password must be 6 or more characters';
  }

  if (!values.newPassword?.trim()) {
    errors.newPassword = 'New password is required';
  } else if (values.newPassword.length < 6) {
    errors.newPassword = 'Password must be 6 or more characters';
  }
  return errors;
};

export default validate;
